<template>
<!-- 业务介绍（红色培训）  企业介绍（关于我们）-->
		<section :id='id' class="feature-area section-padding2">
		  <div class="container">
		    <div class="row">
		      <div class="col-lg-12">
		        <div class="section-top text-center">
		          <h2 :class='id=="yewujieshao"?"title borderCDE":"title"' style='z-index: 100;position: relative;'>{{introduceInfo[0].title}}</h2>
		          <p class='titleShadow' style='z-index: 0;'>{{introduceInfo[0].subTitle}}</p>
		        </div>
		      </div>
		    </div>
		    <div class="row" style='background-color: #b32121;display: flex;border-radius: 8px;align-items: center;overflow: hidden;'>
		      <div class="col-lg-6" style='color: #fff;box-sizing: border-box;padding: 10px 20px;' >
            <p v-html='introduceInfo[0].content'></p>
				  </div>
          <div class="col-lg-6" style='margin: 0;padding: 0;'>
            <img style='width: 100%;' :src="introduceInfo[0].titleImage" alt="古都旅游">
          </div>


		    </div>
		  </div>
		</section>
		<!-- 业务介绍结束 -->
</template>

<script>
  export default{
    props:{
    	type: null,
      url:null,
      id:null
    },
    data(){
      return{
      introduceInfo:[]
      }
    },
    mounted() {
      this.$http({
        method:'get',
        url:'http://123.57.1.182/website/api/website/article/list?type='+this.type,
        data:{}
      }).then((res) => {
        console.log(res)
        if(res.data.code == 200){
          this.introduceInfo = res.data.data
        }
      })
    },

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// introduceEctypal.vue?34afb3e2